import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/ekyc")({
  beforeLoad: () => {
    // eKYCコールバック画面はログイン不要
  },
  component: () => <Outlet />,
});
